module.exports = __webpack_public_path__ + "static/kit3-43a44ec5c884c77c61de891f4b386824.png";